import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { HeaderService } from "src/app/components/header/header.service";
import { IPrintPickItem } from "./print-pick-list/print-pick-item";

@Injectable({
  providedIn: "root",
})
export class ItemPickingService implements OnDestroy {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  private destroy$ = new Subject<void>();
  public baseUrl = `api/itemspicking`;
  constructor(private http: HttpClient) {}

  getPickItems(body: object): Observable<IPrintPickItem> {
    // const url="./assets/TempJson/printPickList.json"
    // return this.http.get<IPrintPickItem>(url);

    const url = this.baseUrl + `/PrintPickList`;
    return this.http.post<IPrintPickItem>(url, body, this.options);
  }
  
  exportPickLists(payload){
    return this.http.post(
      `/${this.baseUrl}/PickItemCSV`,
      payload,
      {
        headers: this.headers,
        observe: "response",
        responseType: "blob",
      }
    );
  }  

  shipmentSkuNotMapped(shipmentHeaderId){
    return this.http.get(
      `/${this.baseUrl}/ShipmentSkuNotMapped?ShipmentHeaderId=${shipmentHeaderId}`,this.options
    );
  }

  batchOrderNotMapped(batchPickingId){
    return this.http.get(
      `/${this.baseUrl}/BatchOrderNotMapped?BatchPickingId=${batchPickingId}`,this.options
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
